<template>
    <div class="country-select" v-click-outside="close">
        <div class="cs-trigger" :class="{ open }" @click="toggle">
            <span class="flag">{{ flagEmoji(value) }}</span>
            <span class="nm">{{ selectedLabel }}</span>
            <span class="cc">{{ value }}</span>
            <span class="car">▾</span>
        </div>
        <div v-if="open" class="cs-pop">
            <div class="cs-search">
                <span>🔍</span>
                <input
                    ref="searchInput"
                    v-model="query"
                    type="text"
                    :placeholder="$t('stripe.country_search_placeholder')"
                />
            </div>
            <div class="cs-list">
                <div
                    v-for="c in filtered"
                    :key="c.value"
                    class="cs-opt"
                    :class="{ act: c.value === value }"
                    @click="select(c)"
                >
                    <span class="flag">{{ flagEmoji(c.value) }}</span>
                    <span class="nm">{{ c.label }}</span>
                    <span class="cc">{{ c.value }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CountrySelect',
    props: {
        value: { type: String, default: '' },
        countries: { type: Array, required: true },
    },
    data() {
        return { open: false, query: '' };
    },
    computed: {
        selectedLabel() {
            const c = this.countries.find(x => x.value === this.value);
            return c ? c.label : '';
        },
        filtered() {
            const q = this.query.trim().toLowerCase();
            if (!q) return this.countries;
            return this.countries.filter(
                c => c.label.toLowerCase().includes(q) || c.value.toLowerCase().includes(q)
            );
        },
    },
    methods: {
        toggle() {
            this.open = !this.open;
            if (this.open) {
                this.query = '';
                this.$nextTick(() => this.$refs.searchInput && this.$refs.searchInput.focus());
            }
        },
        close() { this.open = false; },
        select(c) {
            this.$emit('input', c.value);
            this.close();
        },
        flagEmoji(iso) {
            if (!iso || iso.length !== 2) return '🏳️';
            const A = 0x1f1e6;
            const cc = iso.toUpperCase();
            return String.fromCodePoint(A + cc.charCodeAt(0) - 65) +
                   String.fromCodePoint(A + cc.charCodeAt(1) - 65);
        },
    },
    directives: {
        'click-outside': {
            bind(el, binding) {
                el.__handler = (e) => { if (!el.contains(e.target)) binding.value(e); };
                document.addEventListener('click', el.__handler);
            },
            unbind(el) { document.removeEventListener('click', el.__handler); },
        },
    },
};
</script>

<style lang="scss" scoped>
.country-select { position: relative; }
.cs-trigger {
    display: flex; align-items: center; gap: 11px;
    border: 2px solid #2ED8B6; border-radius: 10px;
    padding: 11px 14px; background: #f4fffb; cursor: pointer;
    .flag { font-size: 21px; }
    .nm { flex: 1; font-size: 14px; font-weight: 500; color: #212541; }
    .cc { font-size: 12px; font-weight: 600; color: #9598a7; }
    .car { color: #2ED8B6; }
}
.cs-pop {
    position: absolute; left: 0; right: 0; z-index: 50; margin-top: 6px;
    border: 1px solid #e3e6ec; border-radius: 10px; background: #fff;
    box-shadow: 0 12px 30px rgba(33,37,65,.15); overflow: hidden;
}
.cs-search {
    display: flex; align-items: center; gap: 8px;
    padding: 11px 14px; border-bottom: 1px solid #eef0f4; color: #9598a7;
    input { border: none; outline: none; flex: 1; font-size: 13px; color: #212541; background: transparent; }
}
.cs-list { max-height: 220px; overflow-y: auto; }
.cs-opt {
    display: flex; align-items: center; gap: 11px; padding: 10px 14px; cursor: pointer;
    &:hover, &.act { background: #f4fffb; }
    .flag { font-size: 19px; }
    .nm { flex: 1; font-size: 14px; color: #212541; }
    .cc { font-size: 12px; font-weight: 600; color: #b4b7c2; }
}
</style>
